import { MarkerClusterer } from "@googlemaps/markerclusterer";

export default class MapMaker {

	static createDynamicMap(element) {
		let map = new google.maps.Map(element, {
			zoom: 10,
			clickableIcons: false,
			disableDefaultUI: true,
			gestureHandling: "none", // empêche tout geste (zoom/pan tactile ou molette)
			draggable: false, // empêche le déplacement à la souris
			mapId: mcArgs.gmapMapId
		});

		map.bounds = new google.maps.LatLngBounds();
		map.markers = [];
		return map;
	}

	static createStaticMap(element, markers) {

		let imgWidth = "640";
		let imgHeight = "640";
		if (element.classList.contains('map-fullwidth')) {
			imgHeight = "360";
		}

		let url = "https://maps.googleapis.com/maps/api/staticmap?";
		url += "key=" + mcArgs.gmapApiKey;
		url += "&map_id=" + mcArgs.gmapMapId;
		url += "&size=" + imgWidth + "x" + imgHeight;
		url += "&scale=2";
		url += "&format=JPEG";

		if (markers.length === 1) {
			url += "&center=" + markers[0].dataset.markerLat + "," + markers[0].dataset.markerLng;
			url += "&zoom=" + element.dataset.zoom;
		}

		markers.forEach((marker) => {
			url += "&markers=";
			url += marker.dataset.markerLat + "," + marker.dataset.markerLng;
			if (marker.dataset.pointer) {
				url += "|icon:" + encodeURI(marker.dataset.pointer);
			}
		});

		let image = new Image();
		image.src = url;
		image.width = imgWidth;
		image.height = imgHeight;
		element.appendChild(image);

	}

	static createMarker(marker, map) {

		const markerElement = document.createElement("div");
		markerElement.style.width = "20px";
		markerElement.style.height = "20px";
		markerElement.style.backgroundColor = "#293193";  // Changez la couleur ici
		markerElement.style.borderRadius = "50%";
		markerElement.style.border = "0px";
		markerElement.style.display = "flex";
		markerElement.style.justifyContent = "center";
		markerElement.style.alignItems = "center";

		let m = new google.maps.marker.AdvancedMarkerElement({
			map,
			position: {
				lat: parseFloat(marker.dataset.markerLat),
				lng: parseFloat(marker.dataset.markerLng)
			},
			content: markerElement // Ajoute l'élément HTML comme marqueur
		});

		map.markers.push(m);
		map.bounds.extend(m.position);
	}

	static initMarkerClusterer(map){

		const renderer = {
			render: ({ count, position }) => {
				// Création d'un élément HTML pour personnaliser l'icône
				const clusterIcon = document.createElement("div");
				clusterIcon.className = "custom-cluster"; // Style CSS
				clusterIcon.textContent = count; // Nombre de marqueurs dans le cluster
				clusterIcon.style.backgroundColor = "#293193"; // Couleur du cluster
				clusterIcon.style.width = "40px"; // Largeur
				clusterIcon.style.height = "40px"; // Hauteur
				clusterIcon.style.borderRadius = "50%"; // Rendre l'icône ronde
				clusterIcon.style.display = "flex";
				clusterIcon.style.alignItems = "center";
				clusterIcon.style.justifyContent = "center";
				clusterIcon.style.color = "white";
				clusterIcon.style.fontSize = "16px";
				clusterIcon.style.fontWeight = "bold";
				clusterIcon.style.cursor = "default";

				return new google.maps.marker.AdvancedMarkerElement({
					position,
					content: clusterIcon,
				});
			}
		};

		const markerCluster = new MarkerClusterer({
			markers: map.markers,
			map,
			renderer,
			onClusterClick: (event) => {
				event.stopPropagation();
			}
		});
	}

	static updateBounds(map) {
		if (map.markers.length > 1) {
			map.fitBounds(map.bounds);
		} else {
			map.setCenter(map.markers[0].position);
		}
	}
}
